import * as R from 'ramda'

import {
  deleteInterviewTemplateQuestion,
  deleteInterviewTemplateSection,
  postInterviewTemplateQuestion,
  postInterviewTemplateSection,
  updateInterviewTemplate,
  updateInterviewTemplateQuestion,
  updateInterviewTemplateSection,
} from 'api/interviewTemplates'

// NOTE: hook that gathers all the data mutation handlers
// which call api with methods like POST, PATCH, PUT, DELETE
// and exposes them for local hooks
export const useMutations = () => {
  const handleDeleteTemplateQuestion = async ({ questions = [] }) =>
    await Promise.all(
      R.map(
        async ({ uuid }) => await deleteInterviewTemplateQuestion({ uuid }),
        questions,
      ),
    )

  const handlePostTemplateQuestion = async ({ questions = [], sectionUrl }) =>
    await Promise.all(
      R.map(
        async ({ description, order, question }) =>
          await postInterviewTemplateQuestion({
            description,
            order,
            section: sectionUrl,
            title: question,
          }),
        questions,
      ),
    )

  const handlePatchTemplateQuestion = async ({ questions = [] }) =>
    await Promise.all(
      R.map(
        async ({ uuid, description, order, question }) =>
          await updateInterviewTemplateQuestion({
            description,
            order,
            title: question,
            uuid,
          }),
        questions,
      ),
    )

  const handleDeleteTemplateSection = async ({ uuid }) =>
    await deleteInterviewTemplateSection({ uuid })

  const handlePostTemplateSection = async ({
    description,
    interviewTemplate,
    key,
    order,
    scoreable,
    title,
  }) =>
    await postInterviewTemplateSection({
      description,
      interviewTemplate,
      key,
      order,
      scoreable,
      title,
    })

  const handlePatchTemplateSection = async ({
    order,
    scoreable,
    title,
    uuid,
  }) => await updateInterviewTemplateSection({ order, scoreable, title, uuid })

  const handlePatchTemplate = async ({ skills, title, uuid }) =>
    await updateInterviewTemplate({
      payload: R.reject(R.isNil, { title, skills }),
      uuid,
    })

  return {
    handleDeleteTemplateQuestion,
    handleDeleteTemplateSection,
    handlePatchTemplate,
    handlePatchTemplateQuestion,
    handlePatchTemplateSection,
    handlePostTemplateQuestion,
    handlePostTemplateSection,
  }
}
